import {
  SVButton,
  SVListFilters,
  SVListPagination,
  SVLoader,
  SVListStats,
} from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useGetTeammatesList } from '@/hooks/requests/useTeammates';
import TeammatesList from '@/components/teammates/TeammatesList';
import { FILTERS } from '@/constants/filters';

export default function TeammatesListPage() {
  const navigate = useNavigate();
  const {
    teammates,
    isTeammatesPending,
    totalRecordCount,
    aggregateInfo,
    isSuccess,
  } = useGetTeammatesList();
  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.STATUS, FILTERS.TEAMMATE_ROLE],
    hasCompanyFilter: true,
    hasTeammateFilter: true,
  });

  const stats = {
    'Total Companies': aggregateInfo?.totalCompanies ?? 0,
    'Total Active Bank Accounts': aggregateInfo?.totalActiveBankAccounts ?? 0,
    'Total Admins': aggregateInfo?.totalAdmins ?? 0,
    'Total Advisors': aggregateInfo?.totalAdvisors ?? 0,
    'Total Supporters': aggregateInfo?.totalSupporters ?? 0,
  };

  return (
    <DefaultLayout
      header={`Teammates ${totalRecordCount ? `(${totalRecordCount})` : ''}`}
      buttons={[
        <SVButton
          onClick={() => navigate(ROUTES.TEAMMATES_ADD)}
          fullWidth
          key="add"
          aria-label="Add Teammate">
          Add
        </SVButton>,
      ]}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by Email Address"
      />
      {isTeammatesPending ? (
        <SVLoader />
      ) : (
        <>
          {teammates.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              {aggregateInfo && <SVListStats stats={stats} />}
              <TeammatesList teammates={teammates} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
